import { FC } from 'react'
import { Route, Routes } from 'react-router-dom'
import { Dashboard, FundingGoals, TotalMatches } from './subComponents'

export const Home: FC = () => {
  return (
    <Routes>
      <Route index path="/" element={<Dashboard />} />
      <Route path="/totalMatches" element={<TotalMatches />} />
      <Route path="/fundingGoals" element={<FundingGoals />} />
    </Routes>
  )
}
